import styled from 'styled-components';

export const HeaderLogo = styled.div(({ color }) => ({
  width: '100%',
  backgroundColor: color,
  display: 'flex',
  justifyContent: 'center',
}));

export const Logo = styled.div(({ imageSrc }) => ({
  background: `url('${imageSrc}')`,
  backgroundPosition: 'center',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  width: '162px',
  height: '49px',
}));

export const LineColor = styled.div(({ height, borderWidth, color, marginTop }) => ({
  height,
  boxSizing: 'border-box',
  borderWidth,
  borderColor: color,
  borderStyle: 'solid',
  marginTop,
  width: '100%',
}));

export const SelectClientWrapper = styled.div`
   {
    width: 100%;
    .select-client__title {
      font-size: 16px;
      font-weight: bold;
    }
    button {
      width: 346px;
      height: 40px;
      span {
        line-height: 1;
        font-size: 14px;
      }
    }
    .group-options__option-list {
      border: unset;
      max-height: 400px;
      overflow: auto;
      ul {
        padding: 0;
        font-size: 14px;
        li {
          input {
            min-width: 15px;
            width: 15px !important;
            height: 15px !important;
          }
          span {
            overflow: hidden;
            white-space: nowrap;
            text-transform: capitalize;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
`;
